import { createStore } from 'effector'
import { produce } from 'immer'

import { AppEvents } from './app.events'

export enum ActiveLocation {
  BPMN_EDITOR = 'bpmn_editor',
  UI_DESIGNER = 'designer',
  BUSINESS_RULE_CONFIG = 'business_rule',
}

export class AppStores {
  static readonly userProfile$ = createStore(null, { name: 'userProfile$' }).on(
    AppEvents.setUserProfile,
    (_, userProfile) => userProfile
  )

  static readonly navigationStack$ = createStore<ActiveLocation[]>([], {
    name: 'navigationStack$',
  })
    .on(AppEvents.processDiagramInit, () => [ActiveLocation.BPMN_EDITOR])
    .on(AppEvents.uiDesignerInit, () => [ActiveLocation.UI_DESIGNER])
    .on(AppEvents.actionEditInit, (state) => [...state, ActiveLocation.BUSINESS_RULE_CONFIG])
    .on(AppEvents.actionEditDestroy, (state) =>
      produce(state, (draft) => {
        draft.pop()
      })
    )
    .reset([AppEvents.processDiagramDestroy, AppEvents.uiDesignerDestroy])

  static readonly activeLocation$ = this.navigationStack$.map(
    (stack) => stack[stack.length - 1] || null
  )

  static readonly isActiveLocationBPMN$ = AppStores.activeLocation$.map(
    (location: ActiveLocation) => location === ActiveLocation.BPMN_EDITOR
  )
}
